export const API_TRADE_REFER_SUMMARY_SUCCESS =
  "API_TRADE_REFER_SUMMARY_SUCCESS";
export const API_TRADE_REFER_SUMMARY_FAIL = "API_TRADE_REFER_SUMMARY_FAIL";
export const GET_TRADE_REFER_SUMMARY = "GET_TRADE_REFER_SUMMARY";
export const GET_TRADE_REFER_SUM = "GET_TRADE_REFER_SUM";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
